<template>
  <div ref="container">
    <div
      v-if="overlayValue"
      class="modal-drop"
      :style="{ padding: modalPadding + 'vh 0' }"
      @click="checkOutside"
    >
      <div class="row dismiss-modal">
        <div class="flex md12 dismiss-modal">
          <va-card
            class="modal-container dismiss-modal"
            :style="{ width: modalWidth + 'vw', height: modalHeight + 'vh' }"
          >
            <div
              v-if="title"
              class="mb-2"
              :style="{ color: this.$themes.primary }"
            >
              {{ title }}
            </div>
            <div
              class="row row-inside px-2"
              :style="{ height: modalHeight * 0.8 + 'vh' }"
            >
              <div class="flex md6">
                <div class="row row-inside">
                  <div class="flex md12 mb-2">
                    {{ prefixUsername }} {{ createur_name }}
                  </div>
                  <div class="flex md12" v-if="!identreprise">
                    <va-select
                      v-if="listEntreprise.length > 0"
                      :options="listEntreprise"
                      v-model="selectedEntreprise"
                      textBy="nom"
                      keyBy="identreprise"
                      searchable
                      label="Entreprise"
                    />
                  </div>
                  <div class="flex md12">
                    <va-select
                      v-if="!idadhesiontype"
                      label="Type d’adhésion"
                      v-model="activeAdhesion"
                      textBy="description"
                      :options="adhesionsOption"
                      no-clear
                    />
                  </div>
                  <div class="flex md6 pr-2">
                    <va-date-picker
                      :config="{ dateFormat: 'd-m-Y' }"
                      label="Date de début d'adhésion"
                      v-model="date_adhesion"
                    />
                  </div>
                  <div class="flex md6 pl-2">
                    <va-date-picker
                      disabled
                      :config="{ dateFormat: 'd-m-Y' }"
                      label="Date de fin d'adhésion"
                      v-model="date_fin"
                    />
                  </div>
                  <div class="flex md12">
                    <va-select
                      label="Mode de paiement"
                      v-model="selectPaiement"
                      textBy="description"
                      :options="paiementOptions"
                      no-clear
                    />
                  </div>
                  <div class="flex md6 pr-2">
                    <va-input
                      v-model="montantPaiement"
                      placeholder="Montant cotisation"
                      label="Montant cotisation"
                    />
                  </div>
                  <div class="flex md6 pl-2">
                    <va-date-picker
                      :config="{ dateFormat: 'd-m-Y' }"
                      label="Date de paiement"
                      v-model="date_paiement"
                    />
                  </div>
                  <div class="flex md12">
                    <va-input
                      v-model="commentaire"
                      label="Commentaire:"
                      type="textarea"
                      autosize
                      :minRows="7"
                      :maxRows="7"
                    />
                  </div>
                  <div class="flex md12">
                    <va-button
                      class="fullwidth"
                      outline
                      v-if="idautres_adhesion"
                      color="danger"
                      @click="deleteAdhesion()"
                      >Supprimer l’adhésion</va-button
                    >
                  </div>
                </div>
              </div>
              <div class="flex md6 px-2">
                <div class="row row-inside">
                  <div class="flex md12 mb-2">
                    <div>Gestion du bulletin d’adhésion:</div>
                  </div>
                  <div class="flex md6 mb-2">
                    <va-button
                      class="fullwidth"
                      outline
                      v-if="
                        !showUpload && !this.fileSave.length > 0 && !deleteFile
                      "
                      color="info"
                      @click="changeFileInit()"
                      >Changer le bulletin</va-button
                    >
                  </div>
                  <div class="flex md6 mb-2">
                    <va-button
                      class="fullwidth"
                      outline
                      v-if="!showUpload && !deleteFile"
                      color="danger"
                      @click="deleteFileInit()"
                      >Supprimer le bulletin</va-button
                    >
                  </div>
                  <div class="flex md12 mb-2">
                    <va-button
                      class="fullwidth"
                      outline
                      v-if="changeFile || deleteFile"
                      color="info"
                      @click="cancelUpload()"
                      >Annuler la modification</va-button
                    >
                  </div>
                  <div class="flex md12">
                    <va-file-upload
                      class="fullsize"
                      type="single"
                      dropzone
                      file-types=".pdf"
                      v-model="file"
                      color="info"
                      v-if="showUpload"
                    />
                    <iframe
                      id="iframeBulletin"
                      ref="iframeBulletin"
                      v-show="
                        (fileUploaded || (pdfurl && !showUpload)) && !deleteFile
                      "
                      class="fullsize"
                      :style="{ height: modalHeight * 0.55 + 'vh' }"
                      :src="pdfSrc"
                    />
                    <div
                      class="solid fullsize"
                      :style="{ height: modalHeight * 0.6 + 'vh' }"
                      @click="displayBulletin"
                      v-if="
                        pdfdisponible &&
                        !showUpload &&
                        !changeFile &&
                        !pdfurl &&
                        !deleteFile
                      "
                    >
                      <va-icon
                        class="center-icon"
                        name="fa fa-eye"
                        color="info"
                        size="5em"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md4 offset--md2 px-2">
                <va-button class="fullwidth" color="gray" @click="cancel()"
                  >Annuler</va-button
                >
              </div>
              <div class="flex md4 px-2">
                <va-button
                  class="fullwidth"
                  color="success"
                  @click="saveAdhesion()"
                  >Sauvegarder</va-button
                >
              </div>
            </div>
          </va-card>
        </div>
      </div>
    </div>
    <va-modal
      :style="{ 'z-index': '1500' }"
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer cette adhésion?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteAdhesion(true)"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { find } from "lodash";

export default {
  name: "autresAdhesionsManager",
  props: {
    value: {
      required: true,
      default: false,
    },
    identreprise: {
      required: false,
      default: null,
    },
    idadhesion: {
      required: false,
      default: null,
    },
    adhesiontype: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      listEntreprise: [],
      selectedEntreprise: "",
      disableActions: false,
      overlayValue: false,
      modalWidth: 60,
      modalHeight: 70,
      title: null,
      idautres_adhesion: null,
      date_adhesion: moment().format("DD-MM-YYYY"),
      pdfdisponible: false,
      idadhesiontype: null,
      commentaire: "",
      createur_name: "",
      file: [],
      fileSave: [],
      pdfurl: null,
      changeFile: false,
      deleteFile: false,
      showConfirmDelete: false,
      activeAdhesion: { id: 0, description: "Choisir le type d’adhésion" },
      adhesionsOption: [
        {
          id: 1,
          description: "SCAPP",
        },
        {
          id: 2,
          description: "OPAM-B",
        },
        {
          id: 3,
          description: "AGROMER",
        },
        {
          id: 6,
          description: "Fédération du Languedoc Roussillon",
        },
        {
          id: 4,
          description: "Fédération de Vendée",
        },
        {
          id: 7,
          description: "S.D.E.P.",
        },
      ],
      activeFederation: { id: 6, description: "Languedoc Roussillon" },
      federationOption: [
        {
          id: 6,
          description: "Languedoc Roussillon",
        },
      ],
      date_paiement: null,
      montantPaiement: null,
      selectPaiement: {
        id: 1,
        description: "inconnu",
      },
      paiementOptions: [
        {
          id: 2,
          description: "Chèque - 1 versement annuel",
        },
        {
          id: 3,
          description: "Virement - 1 versement annuel",
        },
        {
          id: 4,
          description: "Espèces - 1 versement annuel",
        },
        {
          id: 5,
          description: "Prélèvement - 1 prélèvement annuel",
        },
        {
          id: 6,
          description: "Prélèvements - 4 prélèvements annuel",
        },
        {
          id: 7,
          description: "Adhésion offerte",
        },
      ],
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.overlayValue = true;
        window.addEventListener("keyup", this.listenKeyUp);
        this.loadInfos();
        if (!this.identreprise) {
          this.loadListEntreprise();
        }
      } else {
        this.overlayValue = false;
        window.removeEventListener("keyup", this.listenKeyUp);
        this.pdfurl = "";
      }
    },

    fileUploaded(newvalue) {
      if (newvalue && this.deleteFile) {
        this.deleteFile = false;
        this.fileSave = [];
      }
    },
  },
  computed: {
    prefixUsername() {
      if (!this.idautres_adhesion) {
        return "Nouvelle adhésion par";
      } else {
        return "Créé par";
      }
    },
    pdfSrc() {
      if (this.file.length > 0) {
        let url = URL.createObjectURL(this.file[0]);
        return url;
      } else if (this.pdfurl) {
        return this.pdfurl;
      } else {
        return "";
      }
    },
    fileUploaded() {
      return this.file.length > 0 ? true : false;
    },
    showUpload() {
      return (this.changeFile || !this.pdfdisponible) && !this.fileUploaded;
    },
    date_fin: {
      get() {
        return moment(this.date_adhesion, "DD-MM-YYYY")
          .add("years", 1)
          .format("DD-MM-YYYY");
      },
      set(value) {
        // to prevent error but does not change anything
      },
    },

    modalPadding() {
      let halfHeight = 100 - this.modalHeight;
      return halfHeight / 2;
    },
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    document.body.appendChild(this.$refs.container);
  },
  methods: {
    async loadListEntreprise() {
      try {
        let results = await axios.get("/api/liees/list-entreprises");

        this.listEntreprise = results.data;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteAdhesion(isConfirmed) {
      if (isConfirmed) {
        try {
          await axios.delete("api/autres_adhesions", {
            params: { idautres_adhesion: this.idautres_adhesion },
          });
          this.ok();
          this.launchEpicmaxToast("Adhésion supprimée");
        } catch (err) {
          this.launchEpicmaxToast("Erreur lors de la suppression");
        }
      } else {
        this.showConfirmDelete = true;
      }
    },
    async displayBulletin() {
      if (!this.pdfurl) {
        await this.getBulletinURL();
      } else {
        this.displayPdf = true;
      }
    },
    async getBulletinURL() {
      try {
        let resp = await axios.get("api/autres-adhesions/bulletin-adhesion", {
          params: { idautres_adhesion: this.idautres_adhesion },
        });
        this.pdfurl = resp.data;
      } catch (err) {
        //TODO manage error
        this.launchEpicmaxToast("Erreur lors de la recherche du bulletin");

        console.log(err);
      }
    },
    username(prenom, nom, username) {
      let disp = "";

      if (prenom) {
        disp = disp + prenom;
      }
      if (nom) {
        disp = disp + " " + nom;
      }
      if (!disp) {
        disp = username;
      }
      return disp;
    },
    deleteFileInit() {
      if (this.file.length > 0) {
        this.fileSave = this.file;
        this.file = [];
      }
      this.deleteFile = true;
      this.changeFile = false;
    },
    changeFileInit() {
      if (this.file.length > 0) {
        this.fileSave = this.file;
        this.file = [];
      }
      this.changeFile = true;
    },
    cancelUpload() {
      if (this.fileSave.length > 0) {
        this.file = this.fileSave;
        this.fileSave = [];
      }
      this.deleteFile = false;
      this.changeFile = false;
    },
    resetAdhesion(adhesion) {
      this.file = [];
      this.fileSave = [];
      this.deleteFile = false;
      this.changeFile = false;
      if (adhesion) {
        this.idautres_adhesion = adhesion.idautres_adhesion;
        this.date_adhesion = moment(
          adhesion.date_adhesion,
          "YYYY-MM-DD"
        ).format("DD-MM-YYYY");
        this.pdfdisponible = adhesion.pdfdisponible;
        this.commentaire = adhesion.commentaires ? adhesion.commentaires : "";
        this.createur_name = this.username(
          adhesion.prenom,
          adhesion.nom,
          adhesion.username
        );
        this.idadhesiontype = adhesion.idadhesiontype;
        if (this.adhesiontype === "federation") {
          this.activeFederation = find(this.federationOption, [
            "id",
            adhesion.idadhesiontype,
          ]);
        }
        this.date_paiement = adhesion.date_paiement
          ? moment(adhesion.date_paiement, "YYYY-MM-DD").format("DD-MM-YYYY")
          : null;
        this.montantPaiement = adhesion.montant;
        if (adhesion.idpaiement_type) {
          this.selectPaiement = find(this.paiementOptions, [
            "id",
            adhesion.idpaiement_type,
          ]);
          if (!this.selectPaiement) {
            this.selectPaiement = {
              id: 1,
              description: "inconnu",
            };
          }
        }
      } else {
        this.idadhesiontype = null;
        this.idautres_adhesion = null;
        this.date_adhesion = moment().format("DD-MM-YYYY");
        this.pdfdisponible = false;
        this.commentaire = "";
        this.activeFederation = {
          id: 6,
          description: "Languedoc Roussillon",
        };

        // to define how to handle this
        this.createur_name = this.username(
          this.$store.getters.user.prenom,
          this.$store.getters.user.nom,
          this.$store.getters.user.username
        );
        // paiement reset
        this.date_paiement = null;
        this.montantPaiement = null;
        this.selectPaiement = {
          id: 1,
          description: "inconnu",
        };
      }
    },
    async loadInfos() {
      console.log("test");
      console.log(this.idadhesion);
      console.log(this.adhesiontype);
      if (this.idadhesion) {
        try {
          let results = await axios.get("api/autres-adhesions", {
            params: {
              idautres_adhesion: this.idadhesion,
            },
          });

          if (results.data) {
            this.resetAdhesion(results.data);
          } else {
            this.resetAdhesion();
          }
        } catch (err) {
          this.launchEpicmaxToast("Erreur lors du chargement des adhésions");
        }
      } else {
        // create new adhesion
        if (this.adhesiontype) {
          // we know the adhesion type (button from the fiche entreprise)
          this.idadhesiontype = this.adhesiontype;
        } else {
          // New adhesion need to choose the adhesion type
        }
      }
      //set the title
      this.loadTitle();
    },
    loadTitle() {
      let title = "Adhésion à ";
      if (this.idadhesiontype === 1) {
        title += "la SCAPP";
      } else if (this.idadhesiontype === 2) {
        title += "OPAM-B";
      } else if (this.idadhesiontype === 3) {
        title += "AGROMER";
      } else if (this.idadhesiontype === 6) {
        title += "la fédération Languedoc-Roussillon";
      } else if (this.idadhesiontype === 4) {
        title += "la fédération de Vendée";
      } else if (this.idadhesiontype === 7) {
        title += "S.D.E.P.";
      } else {
        title = "Création d'adhésion tierce";
      }
      this.title = title;
    },
    async saveAdhesion() {
      try {
        if (!this.identreprise && !this.selectedEntreprise) {
          this.launchEpicmaxToast("Entreprise non selectionnée");
          return;
        }
        let identreprise;
        if (this.identreprise) {
          identreprise = this.identreprise;
        } else {
          identreprise = this.selectedEntreprise.identreprise;
        }

        console.log(identreprise);
        let formData = new FormData();
        let newPdf = false;
        if (this.file.length > 0) {
          newPdf = true;
          formData.append("bulletin", this.file[0]);
        }

        if (
          !this.idadhesiontype &&
          (!this.activeAdhesion.id || this.activeAdhesion.id <= 0)
        ) {
          this.launchEpicmaxToast(
            "Type d'adhésion inconnu, veuillez choisir un type d’adhésion"
          );
          return;
        } else if (!this.idadhesiontype) {
          this.idadhesiontype = this.activeAdhesion.id;
        }

        let params = {
          idautres_adhesion: this.idautres_adhesion,
          idadhesiontype: this.idadhesiontype,
          date_adhesion: moment(this.date_adhesion, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          date_fin: moment(this.date_fin, "DD-MM-YYYY").format("YYYY-MM-DD"),
          commentaires: this.commentaire,
          newPdf: newPdf,
          deletePdf: this.deleteFile,
          identreprise: identreprise,
          date_paiement: this.date_paiement
            ? moment(this.date_paiement, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
          montantPaiement: this.montantPaiement,
          selectPaiement: this.selectPaiement.id,
        };
        await axios.put("/api/autres-adhesions/upsert-adhesion", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: params,
        });
        this.launchEpicmaxToast("Adhésion sauvegardée.");
        this.ok();
      } catch (error) {
        console.log(error);

        this.launchEpicmaxToast(
          "Erreur lors de la sauvegarde du bulletin. Veuillez rafraichir la page."
        );
      }
    },
    close() {
      this.disableActions = false;
      this.valueProxy = false;
    },
    cancel() {
      this.close();
      this.resetAdhesion();
      this.$emit("cancel");
    },
    ok() {
      this.close();
      this.resetAdhesion();
      this.$emit("ok");
    },
    listenKeyUp(e) {
      if (e.code === "Escape" && !this.noEscDismiss) {
        this.cancel();
      }
    },
    checkOutside(e) {
      if (!this.noOutsideDismiss) {
        let modal;
        e.target.childNodes.forEach((node) => {
          if (node.classList && node.classList.contains("dismiss-modal")) {
            modal = node;
          }
        });
        if (modal && !this.disableActions) {
          this.cancel();
        }
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style>
.modal-drop {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-container {
  box-shadow: $widget-box-shadow;
  z-index: 1001;
  position: relative;
  margin: auto;
}
.solid {
  border: 2px solid #4ab2e3;
  border-radius: 25px;
  position: relative;
}
.solid:hover {
  cursor: pointer;
  background: #e5f5fa;
}
.fullsize {
  width: 100%;
  height: 95%;
}
.center-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.setheight {
  height: 60vh;
}
.actions-container {
  overflow: auto;
  direction: rtl;
}

.fullwidth {
  width: 95%;
}
</style>
